import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuth: false,
  accessToken: null,
  refreshToken: null,
  lastActivityTime: null,
  isSessionTimedOut: false,
  globalError: false,
  errorOriginUrl: null, // New field to store the URL where the error occurred
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setIsAuthenticated: (state, action) => {
      state.isAuth = action?.payload;
      if (action.payload) {
        state.lastActivityTime = Date.now();
        state.isSessionTimedOut = false;
        state.globalError = false;
        state.errorOriginUrl = null; // Reset on successful login
      } else {
        state.lastActivityTime = null;
      }
    },

    setToken: (state, action) => {
      state.accessToken = action.payload.accessToken;
      state.refreshToken = action.payload.refreshToken;
      state.lastActivityTime = Date.now();
      state.isSessionTimedOut = false;
      state.globalError = false;
      state.errorOriginUrl = null;
    },

    setClearAuth: (state) => {
      state.isAuth = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.lastActivityTime = null;
      state.isSessionTimedOut = true;
      state.globalError = false;
      state.errorOriginUrl = null;
    },

    manualLogout: (state) => {
      state.isAuth = false;
      state.accessToken = null;
      state.refreshToken = null;
      state.lastActivityTime = null;
      state.isSessionTimedOut = false;
      state.globalError = false;
      state.errorOriginUrl = null;
    },

    updateLastActivity: (state) => {
      state.lastActivityTime = Date.now();
    },

    setGlobalError: (state, action) => {
      state.globalError = action.payload.globalError; // Expecting { globalError: true, originUrl: "/login" }
      state.errorOriginUrl = action.payload.originUrl || "/"; // Default to "/" if no URL is provided
    },

    resetSessionTimeout: (state) => {
      state.isSessionTimedOut = false;
    },
  },
});

export const {
  setIsAuthenticated,
  setToken,
  setClearAuth,
  manualLogout,
  updateLastActivity,
  resetSessionTimeout,
  setGlobalError,
} = authSlice.actions;
export default authSlice.reducer;